// extracted by mini-css-extract-plugin
export default {"feature-list":"dwHx9","feature-list-item":"Hig3H","icon-wrapper":"KIstq","full-width":"QoZZR","icon":"zbnRR","description":"yB1lQ"};